import * as z from "zod";

export const bulkMarkUnableToPick = {
  name: "bulkMarkUnableToPick" as const,
  input: z.object({ sessionId: z.string() }),
  output: z.object({ markedCount: z.number() }),
};
